import { alpha } from "../../utils/muiCompat";
import cyan from "@material-ui/core/colors/cyan";
import indigo from "@material-ui/core/colors/indigo";
import red from "@material-ui/core/colors/red";
import bg from "../../styles/images/petal_grey_bg.svg";
import bgLight from "../../styles/images/petal_bg.svg";
import cartaoLogin from "../../styles/images/concilia-solucoes/conciliador/login-cartao.jpg";
import { gradientBgLight } from "../../containers/Templates/appStyles-jss";
import { Theme } from "@material-ui/core";
import { darken } from "@material-ui/core/styles/colorManipulator";
import { PALETA_ESCURA } from "../../styles/theme/paletaCores";

const coresLogin = (theme: Theme) =>
  theme.palette.type === "dark"
    ? {
        fundo: PALETA_ESCURA.fundoPagina,
        fundoCampo: PALETA_ESCURA.fundoCartao,
        marca: PALETA_ESCURA.azul,
        botao: PALETA_ESCURA.azulFundo,
        botaoHover: darken(PALETA_ESCURA.azulFundo, 0.25),
        textoBotao: PALETA_ESCURA.textoSobreCor,
        titulo: PALETA_ESCURA.navy,
        texto: PALETA_ESCURA.suave,
        label: PALETA_ESCURA.textoTabela,
        textoCampo: PALETA_ESCURA.navy,
        bordaCampo: PALETA_ESCURA.borda,
        divisor: PALETA_ESCURA.borda,
        rodape: PALETA_ESCURA.fundoMenuLateral,
        sobreposicaoArte: "rgba(18, 20, 23, 0.55)",
        // os icones sao PNG em cinza/azul escuro e somem no fundo escuro
        filtroIcone: "brightness(0) invert(0.75)" as string | undefined,
        // sem isso o Chrome pinta o campo preenchido automaticamente de claro
        autofill: {
          "& input:-webkit-autofill": {
            WebkitBoxShadow: `0 0 0 100px ${PALETA_ESCURA.fundoCartao} inset`,
            WebkitTextFillColor: PALETA_ESCURA.navy,
            caretColor: PALETA_ESCURA.navy
          }
        }
      }
    : {
        fundo: theme.palette.common.white,
        fundoCampo: theme.palette.common.white,
        marca: "#006ad7",
        botao: "#006ad7",
        botaoHover: "#21277b",
        textoBotao: theme.palette.common.white,
        titulo: "#21277b",
        texto: "#69758b",
        label: "#27324b",
        textoCampo: "#27324b",
        bordaCampo: "#d6e4f7",
        divisor: "#d1d9e5",
        rodape: "#21277b",
        sobreposicaoArte: "rgba(0, 106, 215, 0.4)",
        filtroIcone: undefined as string | undefined,
        autofill: {}
      };

const rootWraper = {
  display: "flex",
  width: "100%",
  zIndex: 1,
  position: "relative"
};

const wrapper = (theme: Theme, opacity: number) => ({
  padding: theme.spacing(3),
  textAlign: "center",
  backgroundColor: alpha(theme.palette.background.paper, opacity),
  backgroundRepeat: "no-repeat",
  color: theme.palette.text.primary,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundAttachment: "fixed"
});

const styles = (theme: Theme) => ({
  root: {
    ...rootWraper
  },
  rootFull: {
    ...rootWraper,
    height: "100%"
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      overflow: "hidden"
    }
  },
  containerSide: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      overflow: "hidden"
    }
  },
  paperWrap: {
    ...wrapper(theme, 1)
  },
  sideWrap: {
    ...wrapper(theme, 1),
    height: "100%",
    borderRadius: 0,
    [theme.breakpoints.up("md")]: {
      width: 480
    },
    "& $topBar": {
      marginBottom: theme.spacing(4)
    }
  },
  fullWrap: {
    ...wrapper(theme, 0.9),
    height: "100%",
    borderRadius: 0,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& $topBar": {
      width: "100%"
    }
  },
  petal: {
    backgroundImage: theme.palette.type === "dark" ? `url(${bgLight})` : `url(${bg})`
  },
  icon: {},
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    "& $icon": {
      marginRight: theme.spacing()
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginBottom: theme.spacing(3),
      "& a": {
        display: "none"
      }
    }
  },
  outer: {},
  brand: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px 10px",
    position: "relative",
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.text.primary,
    textDecoration: "none",
    "&$outer": {
      color: theme.palette.common.white
    },
    [theme.breakpoints.down("md")]: {
      margin: theme.spacing(2)
    },
    "& img": {
      width: 30,
      marginRight: 10
    }
  },
  formWrap: {
    [theme.breakpoints.up("sm")]: {
      padding: "0 100px"
    },
    [theme.breakpoints.up("md")]: {
      padding: "0 150px"
    }
  },
  pageFormWrap: {
    width: "100%",
    margin: `${theme.spacing(2)}px auto`,
    [theme.breakpoints.up("sm")]: {
      width: 480
    }
  },
  pageFormSideWrap: {
    margin: "0 auto",
    [theme.breakpoints.only("sm")]: {
      width: 480
    }
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing()
  },
  socmedLogin: {
    [theme.breakpoints.up("sm")]: {
      padding: "24px 100px 1px"
    },
    "& button": {
      padding: "4px 24px"
    }
  },
  socmedSideLogin: {
    padding: "24px 24px 1px",
    margin: "0 auto",
    "& button": {
      padding: "4px 16px",
      margin: `0 ${theme.spacing()}px`
    },
    [theme.breakpoints.only("sm")]: {
      width: 480
    }
  },
  userFormWrap: {
    width: "94%",
    [theme.breakpoints.up("md")]: {
      width: 720
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3)
    }
  },
  sideFormWrap: {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  fullFormWrap: {
    height: "100%",
    width: "100%"
  },
  title: {
    color: theme.palette.primary.main
  },
  subtitle: {
    fontSize: 14
  },
  titleGradient: {
    background: gradientBgLight(theme),
    fontWeight: "bold",
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing(3),
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.55em"
    }
  },
  opening: {
    color: theme.palette.common.white,
    width: "100%",
    textAlign: "center",
    "& h1": {
      display: "block",
      [theme.breakpoints.down("md")]: {
        fontSize: 32,
        lineHeight: "48px"
      }
    },
    "& p": {
      color: theme.palette.common.white,
      fontSize: 18,
      [theme.breakpoints.down("md")]: {
        fontSize: 14
      }
    }
  },
  label: {},
  btnArea: {
    display: "flex",
    justifyContent: "space-around",
    margin: `${theme.spacing(2)}px 0`,
    fontSize: 12,
    "& $label": {
      fontSize: 12,
      "& span": {
        fontSize: 12
      }
    },
    "& button": {
      margin: `0 ${theme.spacing()}px`
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      "& button": {
        width: "100%",
        margin: 5
      }
    }
  },
  noMargin: {
    margin: 0
  },
  redBtn: {
    color: red[500],
    borderColor: red[500],
    "&:hover": {
      borderColor: red[700]
    }
  },
  blueBtn: {
    color: indigo[300],
    borderColor: indigo[300],
    "&:hover": {
      borderColor: indigo[500]
    }
  },
  cyanBtn: {
    color: cyan[500],
    borderColor: cyan[500],
    "&:hover": {
      borderColor: cyan[700]
    }
  },
  buttonLink: {
    background: "none",
    padding: 0,
    textTransform: "none",
    transition: "color ease 0.3s",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: "0.875rem",
    "&:hover": {
      background: "none",
      color: theme.palette.secondary.main
    }
  },
  leftIcon: {
    marginRight: theme.spacing()
  },
  rightIcon: {
    marginLeft: theme.spacing()
  },
  iconSmall: {
    fontSize: 20
  },
  footer: {
    textAlign: "center",
    padding: 5,
    background: theme.palette.grey[100],
    fontSize: 14,
    position: "relative"
  },
  welcomeWrap: {
    position: "relative"
  },
  tab: {
    margin: `${theme.spacing(3)}px 0 ${theme.spacing()}px`
  },
  link: {
    fontSize: "0.875rem",
    color: theme.palette.secondary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  socmedFull: {
    textAlign: "center",
    width: "100%",
    margin: `${theme.spacing(3)}px ${theme.spacing()}px`,
    "& button": {
      width: "100%",
      display: "block",
      margin: `0 auto ${theme.spacing(2)}px`
    },
    [theme.breakpoints.up("sm")]: {
      "& button": {
        width: 400
      }
    }
  },
  lockWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column"
    }
  },
  lockForm: {
    display: "flex",
    alignItems: "baseline"
  },
  notifyForm: {
    alignItems: "baseline",
    [theme.breakpoints.down("xs")]: {
      "& button": {
        marginTop: theme.spacing(3),
        width: "100%"
      }
    },
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      "& button": {
        width: "auto"
      }
    }
  },
  lockField: {
    marginRight: theme.spacing(),
    "& label": {
      color: `${theme.palette.common.white} !important`
    },
    "& label + div": {
      background: alpha(theme.palette.primary.light, 0.3),
      border: "none",
      "& svg": {
        fill: alpha(theme.palette.common.white, 0.7)
      }
    }
  },
  avatar: {
    width: 150,
    height: 150,
    [theme.breakpoints.up("lg")]: {
      marginRight: theme.spacing(3)
    },
    boxShadow: "0 2px 40px -5px black"
  },
  userName: {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightMedium,
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(3),
      textAlign: "center"
    }
  },
  hint: {
    padding: theme.spacing()
  },
  brandCenter: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(3)
  },
  centerAdornment: {
    justifyContent: "center",
    "& > div": {
      width: "100%"
    },
    "& aside": {
      top: -10,
      [theme.breakpoints.up("sm")]: {
        left: 10
      },
      position: "relative"
    }
  },
  centerV: {
    justifyContent: "center"
  },
  optArea: {
    display: "flex",
    justifyContent: "space-between",
    padding: `0 ${theme.spacing() / 2}px`
  },
  conciliaShell: {
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    backgroundColor: coresLogin(theme).fundo
  },
  conciliaMain: {
    flex: 1,
    display: "flex",
    alignItems: "stretch",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  conciliaPainelForm: {
    flex: "1 1 50%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    backgroundColor: coresLogin(theme).fundo,
    "&::after": {
      content: '""',
      position: "absolute",
      right: 0,
      top: 80,
      bottom: 72,
      width: 1,
      backgroundColor: coresLogin(theme).divisor,
      [theme.breakpoints.down("sm")]: {
        display: "none"
      }
    }
  },
  conciliaModoTema: {
    position: "absolute",
    top: theme.spacing(3),
    right: theme.spacing(4),
    display: "flex",
    alignItems: "center",
    color: coresLogin(theme).texto,
    fontSize: 14,
    cursor: "pointer"
  },
  conciliaModoTemaTexto: {
    margin: `0 ${theme.spacing(0.5)}px 0 ${theme.spacing(0.75)}px`
  },
  conciliaFormBox: {
    width: "100%",
    maxWidth: 500
  },
  conciliaTitulo: {
    color: coresLogin(theme).titulo,
    fontWeight: 700,
    fontSize: 42,
    lineHeight: 1.2,
    marginBottom: theme.spacing(),
    [theme.breakpoints.down("md")]: {
      fontSize: 34
    }
  },
  conciliaSubtitulo: {
    color: coresLogin(theme).texto,
    fontSize: 19,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      fontSize: 17
    }
  },
  conciliaLabel: {
    color: coresLogin(theme).label,
    fontSize: 18,
    fontWeight: 500,
    marginBottom: theme.spacing(),
    display: "block"
  },
  conciliaFieldWrap: {
    marginBottom: theme.spacing(3)
  },
  conciliaFieldIcon: {
    width: 20,
    height: 20,
    maxWidth: "none",
    flexShrink: 0,
    filter: coresLogin(theme).filtroIcone
  },
  conciliaField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      backgroundColor: coresLogin(theme).fundoCampo,
      borderRadius: 50,
      height: 64,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: coresLogin(theme).bordaCampo
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: coresLogin(theme).marca
    },
    "& input": {
      padding: "18px 8px",
      fontSize: 18,
      color: coresLogin(theme).textoCampo
    },
    ...coresLogin(theme).autofill,
    "& input::placeholder": {
      color: coresLogin(theme).texto,
      opacity: 1,
      textTransform: "none"
    },
    // o adornment vinha com align-items flex-end + altura 0, deixando o icone acima do centro do campo
    "& .MuiInputAdornment-root": {
      height: "auto",
      maxHeight: "none",
      alignItems: "center"
    },
    "& .MuiIconButton-root": {
      padding: 6,
      color: coresLogin(theme).texto
    },
    [theme.breakpoints.down("md")]: {
      "& .MuiOutlinedInput-root": {
        height: 56
      }
    }
  },
  conciliaOpt: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: -theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  conciliaLink: {
    color: coresLogin(theme).marca,
    textTransform: "none",
    padding: theme.spacing(1, 1.5),
    minWidth: 44,
    minHeight: 44,
    fontSize: 16,
    fontWeight: 500,
    "&:hover": {
      background: "none",
      textDecoration: "underline"
    }
  },
  conciliaEnter: {
    width: "100%",
    height: 64,
    backgroundColor: coresLogin(theme).botao,
    color: coresLogin(theme).textoBotao,
    borderRadius: 50,
    fontSize: 20,
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: coresLogin(theme).botaoHover,
      boxShadow: "none"
    },
    [theme.breakpoints.down("md")]: {
      height: 56,
      fontSize: 18
    }
  },
  conciliaPainelArte: {
    flex: "1 1 50%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: `14vh ${theme.spacing(4)}px ${theme.spacing(4)}px`,
    overflow: "hidden",
    backgroundImage: `url(${cartaoLogin})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: coresLogin(theme).sobreposicaoArte
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  conciliaArteLogo: {
    position: "relative",
    height: 56,
    width: "auto",
    [theme.breakpoints.down("md")]: {
      height: 42
    }
  },
  conciliaArteSlogan: {
    position: "relative",
    marginTop: theme.spacing(4),
    color: theme.palette.common.white,
    fontSize: 34,
    fontWeight: 300,
    lineHeight: 1.4,
    textAlign: "center",
    "& b": {
      fontWeight: 700
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 26
    }
  },
  conciliaFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 100,
    padding: `${theme.spacing(2)}px 72px`,
    backgroundColor: coresLogin(theme).rodape,
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      padding: theme.spacing(2)
    }
  },
  conciliaFooterMarca: {
    color: theme.palette.common.white,
    fontSize: 18,
    fontWeight: 500
  },
  conciliaFooterRedes: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      rowGap: theme.spacing()
    }
  },
  conciliaFooterRedesTitulo: {
    color: theme.palette.common.white,
    fontSize: 16,
    [theme.breakpoints.down("xs")]: {
      flexBasis: "100%",
      textAlign: "center"
    }
  },
  conciliaFooterRede: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.common.white,
    marginLeft: theme.spacing(4),
    textDecoration: "none",
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5)
    },
    "&:hover span, &:focus span": {
      textDecoration: "underline"
    },
    "& svg": {
      fontSize: 22,
      marginRight: theme.spacing()
    },
    "& span": {
      fontSize: 16,
      fontWeight: 500
    }
  }
});

export default styles;
